import React, { useEffect, useRef, useState } from "react";
import "./experience.css";
import { FaGraduationCap, FaUniversity, FaLaptopCode, FaBriefcase } from "react-icons/fa";

// Pulled straight from the CV, oldest first — the trunk fills as you pass each stop.
const milestones = [
  {
    id: 1,
    icon: <FaGraduationCap />,
    tag: "EDUCATION",
    title: "Don Bosco Senior Secondary School",
    role: "Class X & XII, CBSE",
    date: "2017 — 2019",
    points: [
      "93.1% in Class X",
      "78.2% in Class XII (PCM + Computer Science)",
    ],
  },
  {
    id: 2,
    icon: <FaUniversity />,
    tag: "UNIVERSITY",
    title: "University of Mumbai",
    role: "B.E. in Computer Engineering",
    date: "2020 — 2024",
    points: [
      "CGPA 8.84/10",
      "GeeksforGeeks Student Chapter Lead (2022–23)",
      "Core member, Programmer's Club — organized ERR_404 5.0 hackathon",
    ],
  },
  {
    id: 3,
    icon: <FaLaptopCode />,
    tag: "INTERNSHIP",
    title: "Cloud Native Compliance Maven (CNCM) LLC",
    role: "Frontend Developer Intern",
    date: "May 2023 — May 2024",
    points: [
      "Built UI/UX with React.js & Material UI",
      "Improved usability across multiple components",
    ],
  },
  {
    id: 4,
    icon: <FaBriefcase />,
    tag: "CURRENT ROLE",
    title: "Mosaic-Apps",
    role: "Software Engineer — Frontend",
    date: "Jun 2024 — Present",
    points: [
      "React.js, Next.js & TypeScript in production",
      "REST API + Stripe SDK integration",
      "Reusable components with MUI, shadcn/ui & Tailwind CSS",
    ],
  },
];

function Experience() {
  const [activeIndex, setActiveIndex] = useState(-1);
  const nodeRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const idx = Number(entry.target.dataset.index);
          if (entry.isIntersecting) {
            setActiveIndex((prev) => Math.max(prev, idx));
          }
        });
      },
      { threshold: 0.5, rootMargin: "0px 0px -10% 0px" }
    );

    nodeRefs.current.forEach((node) => node && observer.observe(node));
    return () => observer.disconnect();
  }, []);

  const fillPercent =
    activeIndex >= 0 ? ((activeIndex + 1) / milestones.length) * 100 : 0;

  return (
    <section id="experience">
      <h5>The Road So Far</h5>
      <h2>Experience &amp; Education</h2>

      <div className="timeline container">
        <div className="timeline__trunk">
          <div
            className="timeline__trunk-fill"
            style={{ height: `${fillPercent}%` }}
          />
        </div>

        {milestones.map((m, i) => (
          <div
            key={m.id}
            ref={(el) => (nodeRefs.current[i] = el)}
            data-index={i}
            className={`timeline__node ${
              i % 2 === 0 ? "timeline__node--left" : "timeline__node--right"
            } ${i <= activeIndex ? "is-active" : ""}`}
          >
            <div className="timeline__stub" />
            <div className="timeline__dot">{m.icon}</div>
            <div className="timeline__card">
              <span className="timeline__tag">{m.tag}</span>
              <h3>{m.title}</h3>
              <h4>{m.role}</h4>
              <span className="timeline__date">{m.date}</span>
              <ul>
                {m.points.map((p, idx) => (
                  <li key={idx}>{p}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Experience;